import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, timeout: 20000 });

/** Pull a readable message out of an axios error. */
export function errMessage(error, fallback = "Alamak, something went wrong. Try again?") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    if (first?.msg) return first.msg;
  }
  if (error?.message === "Network Error") return "Cannot reach the server. Check your connection.";
  return fallback;
}

export const api = {
  content: () => http.get("/content").then((r) => r.data),
  config: () => http.get("/config").then((r) => r.data),
  plans: () => http.get("/plans").then((r) => r.data),
  faqs: (category) =>
    http.get("/faqs", { params: category ? { category } : {} }).then((r) => r.data),
  downloads: () => http.get("/downloads").then((r) => r.data),
  stats: () => http.get("/stats").then((r) => r.data),
  createLead: (payload) => http.post("/leads", payload).then((r) => r.data),
  createFreeAccess: (payload) => http.post("/free-access", payload).then((r) => r.data),
  createPurchaseIntent: (payload) =>
    http.post("/purchase-intent", payload).then((r) => r.data),
  adminLogin: (token) => http.post("/admin/login", { token }).then((r) => r.data),
  adminSummary: (token) =>
    http.get("/admin/summary", { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  adminList: (token, kind, params = {}) =>
    http
      .get(`/admin/${kind}`, { headers: { "X-Admin-Token": token }, params })
      .then((r) => r.data),
  adminUpdate: (token, kind, id, status) =>
    http
      .patch(`/admin/${kind}/${id}`, { status }, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),
  adminDelete: (token, kind, id) =>
    http
      .delete(`/admin/${kind}/${id}`, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),
};
